<template>
  <div class="inner-main">

    <div class="div-top">
      <span class="org-name">融资历程</span>

      <div class="filter">
        <i class="iconfont iconCommunity"
          style="font-size: 0.875rem; color: #d04a02"></i>
        <van-dropdown-menu>
          <van-dropdown-item v-model="order"
            :options="orderOptions" />
        </van-dropdown-menu>
      </div>

    </div>

    <div class="item"
      v-for="item in dataList"
      :key="item.id">
      <div class="center">
        <div class="top">
          <div class="dot"></div>
        </div>
        <div class="line"></div>
      </div>
      <div class="right1">
        <div class="money">
          {{formatDate(item.fundingDate)}} &nbsp;&nbsp;{{item.round}}
        </div>
        <div class="orgs">
          <span>{{$t('money')}}</span>: {{formatChineseAmount(item.investment,item.currency)}}
        </div>
        <div class="orgs">
          {{item.investors}}
        </div>
      </div>

      <div class="right2">
        <div v-if="item.newsLink&&item.source != '69002'"
          @click="newsClikc(item.newsLink)">新闻</div>

        <div v-if="item.source == '69002'"
          style="color:#323233;font-size:12px;">工商变更</div>
      </div>

    </div>

  </div>
</template>

<script>
import common from "@common/common";
import formatter from "@common/formatter";
export default {
  data () {
    return {
      order: 0,
      orderOptions: [
        {
          text: "按时间排序",
          value: 0,
        }
      ],
    };
  },

  components: {},
  props: {
    dataList: {
      type: Array,
      required: false,
    },
  },
  computed: {},
  mounted () {
    console.log(this.dataList);
  },
  methods: {
    newsClikc (url) {
      window.location.href = url + '?xapp-target=browser';
    },
    ellipsis (val) {
      return common.ellipsis(val, 12);
    },
    formatDate (val) {
      return formatter.formatDate(val);
    },
    formatChineseAmount (val, currency) {
      return formatter.formatChineseAmount(val, currency);
    },
  },
};
</script>
<style lang='less' scoped>
.inner-main {
  padding: 1.125rem;
}

.div-top {
  display: flex;
  align-items: center;
  height: 2.875rem;
  /deep/ .van-dropdown-menu__bar {
    box-shadow: none;
  }
  .org-name {
    flex: 2;
    font-size: 14px;
    font-weight: bolder;
    color: #464646;
  }
  .filter {
    text-align: right;
    flex: 1;
    margin-right: -1rem;

    span {
      font-size: 0.875rem;
    }
    img {
      width: 1.25rem;
      vertical-align: middle;
    }
  }
}

.title {
  font-weight: 600;
  font-size: 20px;
  // margin-top: 6px;
  color: #464646;
}

.item {
  display: flex;
  margin-bottom: 26px;
}
@l-height: 36px;
@black: #1d1d1d;
.left {
  text-align: right;
  width: 80px;
  .round {
    color: @black;
    font-size: 16px;
    font-weight: 550;
    line-height: @l-height;
  }
}
.center {
  margin-left: 10px;
  margin-right: 20px;
  .top {
    position: relative;
    .dot {
      position: absolute;
      left: 0;
      top: 5px;
      transform: translateX(-50%);
      background-color: #7d7d7d;
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }
  }
  .line {
    margin-top: 24px;
    height: 100%;
    border-left: 1px solid #cacaca;
  }
}
.right1 {
  font-size: 15px;
  .money {
    color: @black;
  }
  .orgs {
    width: 16rem;
  }
}

.right2 {
  font-size: 15px;
  font-size: 15px;
  width: 3rem;
  text-align: center;
  color: #c52a1a;
}
</style>


// WEBPACK FOOTER //
// src/components/content/invested/InvestedHis.vue